import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  InjectionToken,
  Input,
  OnInit,
  Optional
} from '@angular/core';

export interface RadioGroup {
  name: string;
  disabled: boolean;
  value: any;
  onChange(value: any): void;
}

export const RADIO_GROUP = new InjectionToken<RadioGroup>('RADIO_GROUP');

@Component({
  selector: 'gcc-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonComponent implements OnInit {
  @Input() public id: string;

  @Input()
  get value(): any {
    return this._value;
  }
  set value(value: any) {
    if (this._value !== value) {
      this._value = value;
    }
  }

  @Input()
  get disabled(): boolean {
    return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
  }
  set disabled(value: boolean) {
    this._setDisabled(value);
  }

  get checked(): boolean {
    return this.radioGroup && this.radioGroup.value === this._value;
  }

  public name: string;

  private _value: any = null;
  private _disabled: boolean;

  constructor(
    @Optional() @Inject(RADIO_GROUP) private radioGroup: RadioGroup,
    private changeDetector: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    if (this.radioGroup) {
      this.name = this.radioGroup.name;
    }
  }

  public markForCheck() {
    this.changeDetector.markForCheck();
  }

  public onInputClick(event: Event) {
    event.stopPropagation();
  }
  public onInputChange(event: Event) {
    event.stopPropagation();
    if (this.radioGroup) {
      this.radioGroup.onChange(this.value);
    }
  }

  public setDisabled(isDisabled: boolean) {
    this._setDisabled(isDisabled);
    this.markForCheck();
  }

  private _setDisabled(value: boolean) {
    if (this._disabled !== value) {
      this._disabled = value;
      this.changeDetector.markForCheck();
    }
  }
}
